<template>
  <MessageComposer
    outlined
    rows="4"
    submitButtonTestId="comments-addon__submit"
    :placeholder="customFooterPlaceholder"
    :accountSuggestions="accountSuggestions"
    :initialMentionedAccounts="initialMentionedAccounts"
    :initialMessage="initialMessage"
    :isSearchingAccounts="isSearchingAccounts"
    :textareaTestId="textareaTestId"
    :hasCustomFooter="hasCustomFooter"
    :validator="validator"
    @searchAccounts="searchAccounts"
    @submit="handleSubmit"
    @cancel="handleCancel"
  >
    <template v-slot:footer="{ triggerSubmit, triggerCancel }">
      <slot
        name="footer"
        :triggerSubmit="triggerSubmit"
        :triggerCancel="triggerCancel"
      />
    </template>
  </MessageComposer>
</template>

<script>
import { mapGetters } from 'vuex'

import api from '@/api'

import userMixin from '@/mixins/userMixin.vue'

import MessageComposer from '@/components/MessageComposer.vue'

const SORT_BY_COINCIDENCE = '_score'

export default {
  name: 'CommentComposer',

  mixins: [userMixin],

  components: {
    MessageComposer,
  },

  props: {
    textareaTestId: String,
    replyTo: Object,
    hasCustomFooter: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    validator: {
      type: Function,
    },
  },

  data() {
    return {
      accountSuggestions: [],
      isSearchingAccounts: false,
      initialMessage: '',
      initialMentionedAccounts: [],
    }
  },

  computed: {
    ...mapGetters(['organizationId']),

    customFooterPlaceholder() {
      return this.placeholder || ''
    },
  },

  created() {
    this.searchAccounts()
  },

  watch: {
    async replyTo(account) {
      this.initialMessage = ''
      await this.$nextTick()
      this.initialMessage = account ? `@${account?._id ?? account?.id} ` : ''
      this.initialMentionedAccounts = account ? [account] : []
    },
  },

  methods: {
    async searchAccounts(searchTerms) {
      this.isSearchingAccounts = true

      const response = await api.account.searchPeople(this.organizationId, {
        filters: { isDeleted: false, status: 'joined' },
        terms: searchTerms,
        sort: {
          by: SORT_BY_COINCIDENCE,
          order: 'desc',
        },
      })

      this.accountSuggestions =
        response?.data?.results?.map?.(result => result.account) ?? []

      this.isSearchingAccounts = false
    },

    handleSubmit({ message, accountIds }) {
      this.$emit('submit', {
        content: message,
        accounts: accountIds,
      })
    },

    handleCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
